var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 4,
    fill: "none",
    stroke: "#272726",
    strokeLinejoin: "round",
    className: "bell_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 43.306a5.987 5.987 0 0010 0M38 22v-6a14 14 0 00-28 0v6c0 6.7-6 8.2-6 12 0 3.3 7.7 6 20 6s20-2.7 20-6c0-3.8-6-5.3-6-12z"
  }))));
}

export default SvgBell;